import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import StatisticsCard from './StatisticsCard';
import { actionStatisticsService, ActionStatistics } from '../../services/ActionStatisticsService';

const NotStartedActionsCard: React.FC = () => {
	const [loading, setLoading] = useState<boolean>(true);
	const [data, setData] = useState<ActionStatistics | null>(null);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const result = await actionStatisticsService.getNotStartedActions();
				setData(result);
			} catch (error) {
				console.error('Error fetching not started actions:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	const handleClick = () => {
		navigate('/tw/plano-de-acao?situacao=Pendente');
	};

	return (
		<StatisticsCard
			title="Não Iniciadas"
			value={data?.count ?? 0}
			loading={loading}
			color="#9e9e9e"
			icon={<HourglassEmptyOutlinedIcon fontSize="large" />}
			subtitle="Ações pendentes e planejadas"
			onClick={handleClick}
		/>
	);
};

export default NotStartedActionsCard;
